<!-- NotFound.vue -->
<template>
    <div dir="rtl">
        <h1>الصفحة غير موجودة</h1>
        <p>عذرا، الصفحة التي تبحث عنها غير موجودة.</p>
    </div>
</template>
  
<script>
export default {
    // Component options
};
</script>
  
<style scoped>
/* Component-specific styles if needed */
</style>
  